import React, { useCallback, useEffect, useRef,} from "react";
import { useState } from "react";
import { useParams } from "react-router";
import SnackbarUtils from "../../../libs/SnackbarUtils";
import historyUtils from "../../../libs/history.utils";
import LogUtils from "../../../libs/LogUtils";
import {
  serviceCreateCity,
  serviceUpdateCity,
  serviceDeleteCity,
 
} from "../../../services/City.service";

import { useDispatch, useSelector } from "react-redux";
import { actionFetchCity } from "../../../actions/City.action";
function usePopularCityCreateHook({ isOpen, handleToggle, editData, handleSideToggle, isSidePanel }) {
  const initialForm = {
    icon: "",
    name: "",
    priority: "",
    status: true,
    is_popular: true,
  };
  
  const [form, setForm] = useState({ ...initialForm });
  const [errorData, setErrorData] = useState({});
  const [images, setImages] = useState(null);
  const [isSubmitting, setIsSubmitting] = useState(false);
  const [resData, setResData] = useState([]);
  const [image, setImage] = useState(null);
  const [loading, setLoading] = useState(false);
  const [successMessage, setSuccessMessage] = useState("");
  const dispatch = useDispatch();
  const [listData, setListData] = useState({
    ROLES: [],
    UNITS: [],
  });
  const [isDialogOpen, setIsDialogOpen] = useState(false);
  const { id: stateId } = useParams();
  console.log('state_id:', stateId);
  const openDialog = () => {
    setIsDialogOpen(true);
  };

  const closeDialog = () => {
    setIsDialogOpen(false);
  };

  useEffect(() => {
    if (isOpen) {
      setForm({ ...initialForm });
      setResData([]);
      setIsSubmitting(false);
      setErrorData({});
    }
  }, [isOpen]);

  // console.log("id before useEffect: ", id);
  useEffect(() => {
    if (editData?.id) {
      setForm({
        ...form,
        name: editData?.name,
        priority: editData?.priority || 0,
        is_popular: editData?.is_popular ? true : false,
        status: editData?.status === "ACTIVE",
        icon_url:editData?.icon,
        icon:null
      });
      setImage(editData?.icon || null);
    }
  }, [editData?.id]);
console.log(image, "popular icon: ")
  const checkFormValidation = useCallback(() => {
    const errors = {};
    let required = ["name", "priority"];
    // if(form?.is_popular){
      
    // }
    if (form?.is_popular && !form?.icon && !form?.icon_url) {
      required.push("icon")
    }
    required.forEach((val) => {
      if (
        (!form?.[val] && parseInt(form?.[val]) != 0) ||
        (Array.isArray(form?.[val]) && form?.[val]?.length === 0)
      ) {
        errors[val] = true;
      }
    });
    if (form?.name?.length < 2) {
      errors["name"] = true;
    }
    if (form?.code?.length < 2) {
      errors["code"] = true;
    }
    if (
      form?.priority !== "" && 
      (isNaN(Number(form?.priority)) || Number(form?.priority) < 0)
    ) {
      errors["priority"] = true; 
    }
    Object.keys(errors).forEach((key) => {
      if (!errors[key]) {
        delete errors[key];
      }
    });
    return errors;
  }, [form, errorData]);

  const removeError = useCallback(
    (title) => {
      const temp = JSON.parse(JSON.stringify(errorData));
      temp[title] = false;
      setErrorData(temp);
    },
    [setErrorData, errorData]
  );

  const changeTextData = useCallback(
    // (text, fieldName) => {
    //   let shouldRemoveError = true;
    //   const t = { ...form };
    (value, fieldName) => {
      let updatedForm = { ...form };

      if (fieldName === "is_popular") {
        updatedForm.is_popular = value;
      }else if (fieldName === "priority") {
        
        if (value === "" || (!isNaN(value) && Number(value) >= 0)) {
          updatedForm.priority = value; 
        }
      }  else {
        updatedForm[fieldName] = value;
      }

      setForm(updatedForm);
      removeError(fieldName);
    },
    [removeError, form, setForm]
  );

  const submitToServer = useCallback(() => {
    if (!isSubmitting) {
      setIsSubmitting(true);

      const errors = {};
      if (!form.name.trim()) {
        errors.name = "City Name is required";
      }

      if (Object.keys(errors).length > 0) {
        setErrorData(errors);
        setIsSubmitting(false);
        return;
      }
      const formData = new FormData();
      Object.keys(form).forEach((key) => {
        if (key !== "icon") {
          if (key === "status") {
            formData.append("is_active", form[key] ? true : false);
          } else if (key === "is_popular") {
            formData.append(key, form[key] ? true : false);
          } else if (key !== "icon_url" && form[key]) {
            formData.append(key, form[key]);
          }
        }
      });
      // if (form?.icon) {
      //   formData.append("icon", form?.icon);
      // }
      if (editData?.state?.id) {
        formData.append("state_id", editData?.state?.id);
      }
      let req;
      console.log("id", editData?.id);
      if (editData?.id) {
        formData.append("id", editData?.id);
        req = serviceUpdateCity(formData);
      } else {
        req = serviceCreateCity(formData);
      }

      req.then((res) => {
        if (!res.error) {
         
          SnackbarUtils.success(editData?.id ? "Updated successfully!" : "Created successfully!");
          
          // handleToggle(); 
          handleSideToggle();
          //window.location.reload();
          dispatch(
            actionFetchCity(
              1,
              {},
              {
                
              is_popular: true,
              }
            )
          );
       
        } else {
          SnackbarUtils.error(res.message);
          if (res.message.includes("Name already exists")) {
            setErrorData((prev) => ({ ...prev, name: true }));
          }
          setIsSubmitting(false);
          
        }
        // setIsSubmitting(false);
      });
    }
  }, [form, isSubmitting, setIsSubmitting, setErrorData, editData, handleToggle, handleSideToggle]);

  const onBlurHandler = useCallback(
    (type) => {
      if (form?.[type]) {
        changeTextData(form?.[type].trim(), type);
      }
    },
    [changeTextData]
  );

  const handleSubmit = useCallback(
    async (status) => {
      const errors = checkFormValidation();
      LogUtils.log("errors==>", errors);
      if (Object.keys(errors)?.length > 0) {
        setErrorData(errors);
        return true;
      }
      submitToServer(status);
    },
    [checkFormValidation, setErrorData, form, submitToServer]
  );

  

  return {
    form,
    errorData,
    listData,
    resData,
    changeTextData,
    onBlurHandler,
    removeError,
    handleSubmit,
    isSubmitting,
    images,
   loading,
    editData,
    openDialog,
    closeDialog,
    isDialogOpen,
    image,
    stateId
  };
}

export default usePopularCityCreateHook;
